import React, { useState } from "react";
import PropTypes from "prop-types";
import { validateCel } from "../api";

const AdvancedCelEditor = ({ value, onChange, onBack }) => {
  const [result, setResult] = useState(null);
  const [checking, setChecking] = useState(false);

  const validate = async () => {
    setChecking(true);
    try {
      const r = await validateCel({ expression: value });
      setResult(r);
    } catch (e) {
      setResult({ valid: false, error_details: "Validation request failed" });
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <p className="text-xs font-medium uppercase tracking-wide text-text-2">Advanced — CEL expression</p>
        <button type="button" onClick={onBack} className="text-xs text-text-2 hover:text-text">← Back to picker</button>
      </div>
      <textarea
        aria-label="cel expression" value={value} onChange={(e) => onChange(e.target.value)} rows={4}
        placeholder="resource.labels['env'] == 'prod'"
        className="w-full border border-border rounded-ctrl px-3 py-2 text-sm font-mono focus:outline-none focus:ring-1 focus:ring-primary"
      />
      <div className="flex items-center gap-3">
        <button type="button" onClick={validate} disabled={checking || !value.trim()}
          className="px-3 py-1.5 text-xs rounded-ctrl border border-border text-text hover:bg-surface-2 disabled:opacity-40">
          {checking ? "Validating…" : "Validate"}
        </button>
        {result?.valid && <span className="text-xs text-success">Expression is valid ✓</span>}
        {result && !result.valid && <span className="text-xs text-danger">{result.error_details || "Invalid expression"}</span>}
      </div>
      <p className="text-xs text-text-3 italic">Cost preview is not available for advanced expressions — the source will appear in the matrix after the next allocation run.</p>
    </div>
  );
};

AdvancedCelEditor.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default AdvancedCelEditor;
